import { IMAGES } from "@/config";

export const CATEGORIES = [
  { slug: "hair", name: "Hair Studio", short: "Hair", path: "/hair-studio" },
  { slug: "nails", name: "Nail Lounge", short: "Nails", path: "/nail-lounge" },
  { slug: "facials", name: "Esthetics & Facials", short: "Facials", path: "/esthetics-facials" },
  { slug: "waxing", name: "Waxing & Hair Removal", short: "Waxing", path: "/waxing" },
];

export const SERVICES = {
  hair: {
    slug: "hair",
    kicker: "01 — Hair Studio",
    name: "Hair Studio",
    path: "/hair-studio",
    image: IMAGES.hair,
    imageAlt: "Editorial balayage color transformation at a Hell's Kitchen hair salon",
    headline: "Cut, color & balayage engineered for New York light.",
    intro:
      "From lived-in balayage to precision cuts and blowouts that survive a Midtown summer, our color directors train in the same techniques used backstage at NYFW — reimagined for real Hell's Kitchen schedules.",
    seoTitle: "Best Balayage & Hair Color in Hell's Kitchen, NYC | Maison Neuf Hair Studio",
    seoDesc:
      "Book expert balayage, hair coloring, cuts and styling in Hell's Kitchen, Manhattan. Premium color lines, transparent pricing, and NYC's most requested colorists at Maison Neuf.",
    menu: [
      { name: "Precision Cut & Style", price: "$95+", duration: "60 min", desc: "Consultation, shampoo ritual, tailored cut and finish." },
      { name: "Signature Blowout", price: "$65", duration: "45 min", desc: "Smooth, voluminous, red-carpet ready." },
      { name: "Full Balayage", price: "$285+", duration: "180 min", desc: "Hand-painted, dimensional, lived-in color." },
      { name: "Full Highlights", price: "$220+", duration: "150 min", desc: "Foil technique for brightness and contrast." },
      { name: "Single-Process Color", price: "$110+", duration: "90 min", desc: "Root-to-tip gloss or coverage." },
      { name: "Gloss & Toner Refresh", price: "$75", duration: "45 min", desc: "Between-visit shine and tone correction." },
    ],
    addOns: ["Olaplex bond builder — $35", "Scalp detox treatment — $40", "Deep-conditioning mask — $30"],
    brands: ["Redken Shades EQ", "Wella Professionals", "Olaplex", "Oribe", "Kevin Murphy"],
    why: [
      "Dedicated color directors with 10+ years on set and salon floor.",
      "Complimentary bond-protection with every lightening service.",
      "Ammonia-optional and low-tox color formulas available on request.",
    ],
    related: [
      { label: "Add a custom facial", path: "/esthetics-facials" },
      { label: "Brow shaping to finish", path: "/waxing" },
    ],
  },
  nails: {
    slug: "nails",
    kicker: "02 — Nail Lounge",
    name: "Nail Lounge",
    path: "/nail-lounge",
    image: IMAGES.nails,
    imageAlt: "Luxury gel manicure with editorial nail art in NYC nail lounge",
    headline: "Manicures, gel & nail art in a spotless, air-purified lounge.",
    intro:
      "Our nail artists work with non-toxic, breathable polishes and hospital-grade sanitation. Whether you want a quiet gel manicure before a meeting or full sculpted art, we keep it clean, precise, and unmistakably NYC.",
    seoTitle: "Gel Manicure & Nail Art Near Me | Nail Lounge Hell's Kitchen NYC | Maison Neuf",
    seoDesc:
      "Gel manicures, pedicures, nail art and acrylics in Hell's Kitchen, Manhattan. Non-toxic polishes, medical-grade sanitation, expert nail artists. Book your NYC manicure today.",
    menu: [
      { name: "Classic Manicure", price: "$40", duration: "40 min", desc: "Shape, cuticle care, polish." },
      { name: "Gel Manicure", price: "$60", duration: "55 min", desc: "Two-week chip-free wear." },
      { name: "Luxury Spa Pedicure", price: "$85", duration: "70 min", desc: "Soak, exfoliation, massage, polish." },
      { name: "Builder Gel / Acrylic Set", price: "$95+", duration: "90 min", desc: "Sculpted strength and length." },
      { name: "Nail Art (per nail)", price: "$8+", duration: "varies", desc: "Chrome, French, hand-painted detail." },
      { name: "Gel Removal & Reset", price: "$20", duration: "25 min", desc: "Gentle soak-off and nail recovery." },
    ],
    addOns: ["Paraffin hand treatment — $18", "French tip — $12", "Chrome / cat-eye finish — $15"],
    brands: ["OPI", "Dazzle Dry (non-toxic)", "The GelBottle Inc", "Bio Sculpture"],
    why: [
      "Autoclave-sterilized tools; single-use files for every guest.",
      "Breathable, 10-free polish systems for healthier nails.",
      "Nail artists trained in structured gel and freehand art.",
    ],
    related: [
      { label: "Pair with a pedicure", path: "/nail-lounge" },
      { label: "Add a glow facial", path: "/esthetics-facials" },
    ],
  },
  facials: {
    slug: "facials",
    kicker: "03 — Esthetics & Facials",
    name: "Esthetics & Facials",
    path: "/esthetics-facials",
    image: IMAGES.facial,
    imageAlt: "Custom facial and skincare treatment in a Hell's Kitchen esthetics studio",
    headline: "Custom facials, peels & HydraFacial for real city skin.",
    intro:
      "Pollution, hard water, and late nights are hard on skin. Our licensed estheticians build every facial around your barrier — using medical-grade actives, gentle resurfacing, and results you can see before you're back on Ninth Avenue.",
    seoTitle: "Custom Facials, Peels & HydraFacial in Hell's Kitchen, New York | Maison Neuf",
    seoDesc:
      "Book a custom facial, chemical peel or HydraFacial in Hell's Kitchen, NYC. Medical-grade skincare, licensed estheticians, glow-focused treatments for busy New Yorkers.",
    menu: [
      { name: "Maison Custom Facial", price: "$140", duration: "60 min", desc: "Fully tailored cleanse, treat, and glow." },
      { name: "Signature HydraFacial", price: "$210", duration: "60 min", desc: "Cleanse, extract, hydrate with serums." },
      { name: "Resurfacing Peel", price: "$165", duration: "45 min", desc: "Professional acids for tone and texture." },
      { name: "Back Facial", price: "$150", duration: "50 min", desc: "Deep cleanse for hard-to-reach skin." },
      { name: "Express Glow (30)", price: "$85", duration: "30 min", desc: "Lunch-break refresh and hydration." },
      { name: "Dermaplaning Add-On", price: "$45", duration: "20 min", desc: "Smooth, luminous, makeup-ready skin." },
    ],
    addOns: ["LED light therapy — $40", "Eye contour treatment — $30", "Lip resurfacing — $25"],
    brands: ["HydraFacial", "SkinCeuticals", "Dermalogica PRO", "iS Clinical"],
    why: [
      "Licensed medical estheticians, not one-size-fits-all protocols.",
      "Barrier-first approach designed for pollution-exposed city skin.",
      "Honest homecare guidance — no upsell pressure.",
    ],
    related: [
      { label: "Add lash lamination", path: "/waxing" },
      { label: "Finish with a blowout", path: "/hair-studio" },
    ],
  },
  waxing: {
    slug: "waxing",
    kicker: "04 — Waxing & Hair Removal",
    name: "Waxing & Hair Removal",
    path: "/waxing",
    image: IMAGES.waxing,
    imageAlt: "Brow shaping and waxing service at a Hell's Kitchen waxing studio NYC",
    headline: "Gentle waxing, brow design & lash lamination.",
    intro:
      "Fast, hygienic, and genuinely comfortable. We use low-temperature hard wax and a strict single-use policy, so brows, body, and lashes are handled with clinical care and zero double-dipping — ever.",
    seoTitle: "Waxing Studio, Brows & Lash Lamination in Hell's Kitchen, NYC | Maison Neuf",
    seoDesc:
      "Body waxing, brow shaping, and lash lamination in Hell's Kitchen, Manhattan. Low-temp hard wax, single-use hygiene, expert estheticians. Book your NYC waxing appointment.",
    menu: [
      { name: "Brow Shaping & Design", price: "$35", duration: "20 min", desc: "Mapped, tailored to your face." },
      { name: "Lash Lamination", price: "$95", duration: "50 min", desc: "Lifted, fuller lashes for weeks." },
      { name: "Brow Lamination + Tint", price: "$110", duration: "55 min", desc: "Fluffy, defined, low-maintenance brows." },
      { name: "Underarm Wax", price: "$28", duration: "15 min", desc: "Quick, smooth, gentle." },
      { name: "Full Leg Wax", price: "$85", duration: "45 min", desc: "Silky, long-lasting results." },
      { name: "Brazilian Wax", price: "$70", duration: "30 min", desc: "Expert, comfortable, discreet." },
    ],
    addOns: ["Brow tint — $20", "Post-wax soothing mask — $15", "Ingrown-hair treatment — $18"],
    brands: ["Cirépil (low-temp hard wax)", "Berodin", "Elleebana lash systems"],
    why: [
      "Strict no double-dip, single-use applicator policy.",
      "Low-temperature hard wax for sensitive skin comfort.",
      "Brow mapping tailored to your natural features.",
    ],
    related: [
      { label: "Pair with a facial", path: "/esthetics-facials" },
      { label: "Book a gel manicure", path: "/nail-lounge" },
    ],
  },
};

export const TEAM = [
  { name: "Simone Vega", role: "Creative Director · Color", specialty: "Dimensional balayage & color correction", img: IMAGES.team[0], handle: "@simone.color" },
  { name: "Lena Ash", role: "Lead Stylist", specialty: "Precision cuts & editorial styling", img: IMAGES.team[1], handle: "@lena.cuts" },
  { name: "Priya Rao", role: "Lead Esthetician", specialty: "HydraFacial & resurfacing peels", img: IMAGES.team[2], handle: "@priya.skin" },
  { name: "Noa Kim", role: "Master Nail Artist", specialty: "Structured gel & freehand art", img: IMAGES.team[3], handle: "@noa.nails" },
];

export const GALLERY = [
  { id: 1, cat: "hair", title: "Copper Balayage Correction", img: IMAGES.hair, path: "/hair-studio" },
  { id: 2, cat: "hair", title: "Cool Blonde Transformation", img: IMAGES.hairAlt, path: "/hair-studio" },
  { id: 3, cat: "nails", title: "Chrome French Set", img: IMAGES.nails, path: "/nail-lounge" },
  { id: 4, cat: "nails", title: "Editorial Spa Manicure", img: IMAGES.nailsAlt, path: "/nail-lounge" },
  { id: 5, cat: "facials", title: "HydraFacial Glow", img: IMAGES.facial, path: "/esthetics-facials" },
  { id: 6, cat: "facials", title: "Barrier Repair Facial", img: IMAGES.facialAlt, path: "/esthetics-facials" },
  { id: 7, cat: "waxing", title: "Brow Lamination + Tint", img: IMAGES.waxing, path: "/waxing" },
  { id: 8, cat: "waxing", title: "Lash Lamination Lift", img: IMAGES.waxingAlt, path: "/waxing" },
];

export const BEFORE_AFTER = [
  { id: 1, cat: "hair", title: "Brunette → Lived-in Blonde", before: IMAGES.baHairBefore, after: IMAGES.baHairAfter },
  { id: 2, cat: "facials", title: "Dull → Luminous Skin", before: IMAGES.baFacialBefore, after: IMAGES.baFacialAfter },
];

export const REVIEWS = [
  { name: "Jordan M.", area: "Hell's Kitchen", text: "The only colorist in NYC I trust with my blonde. Simone read my hair perfectly and the balayage grew out flawlessly.", stars: 5 },
  { name: "Aisha R.", area: "Midtown West", text: "Cleanest nail lounge I've been to in the city. Gel lasted almost three weeks and the art was unreal.", stars: 5 },
  { name: "Daniel K.", area: "Chelsea", text: "Got the HydraFacial before a shoot and my skin has never looked better on camera. Priya is a magician.", stars: 5 },
  { name: "Mara L.", area: "Times Square", text: "Fast, spotless, and genuinely kind staff. The brow lamination changed my whole morning routine.", stars: 5 },
];

export const PRESS = ["VOGUE", "ALLURE", "REFINERY29", "TIME OUT NY", "THE CUT", "ELLE"];

export const FAQS = [
  { q: "Do I need an appointment or can I walk in?", a: "We recommend booking online in advance — Hell's Kitchen fills up fast. We hold a limited number of same-day slots for walk-ins when availability allows." },
  { q: "What is your cancellation policy?", a: "We kindly ask for 24 hours' notice. Late cancellations and no-shows may incur a fee of up to 50% of the service, as outlined in our salon policies." },
  { q: "Are your products clean / non-toxic?", a: "Our nail lounge uses 10-free, breathable polishes, and we offer ammonia-optional color and barrier-first skincare. Ask your specialist for the full ingredient rundown." },
  { q: "How do you handle hygiene and sanitation?", a: "Autoclave-sterilized tools, single-use files and applicators, hospital-grade surface disinfection, and air purification throughout the studio." },
  { q: "Do you offer consultations before color or peels?", a: "Yes. Every color and resurfacing service begins with a complimentary consultation and patch test where appropriate." },
  { q: "Where exactly are you located?", a: "555 Ninth Avenue in Hell's Kitchen — three minutes from the A/C/E at 42nd St–Port Authority, between W 40th and W 41st Street." },
];

export const MEMBERSHIPS = [
  { name: "The Glow Pass", price: "$120", cadence: "/ month", perks: ["One express facial or blowout monthly", "10% off all add-ons", "Priority booking window", "Rollover unused visits (60 days)"], featured: false },
  { name: "The Maison Member", price: "$220", cadence: "/ month", perks: ["One signature service monthly (hair, nails, or facial)", "15% off all services & retail", "Complimentary brow shaping", "Members-only events & early color drops"], featured: true },
  { name: "The Atelier", price: "$420", cadence: "/ month", perks: ["Two premium services monthly", "20% off everything", "Dedicated specialist & concierge booking", "Guest passes & seasonal gifting"], featured: false },
];
